import Network from 'infrastructure/js/modules/network';
import { api as messageDialogApi } from '../../../MessageDialog/messageDialogActions.js';
import * as toolsService from '../../../../services/Tools/toolsService';
import * as kitTypesService from '../../../../services/KitTypes/kitTypesService';
import * as locationsService from '../../../../services/Locations/locationsService';
import * as operationsService from '../../../../services/Operations/operationsService';
import uniqBy from 'lodash-es/uniqBy';
import {createDialogActions} from '../../../Dialogs/CommonDialog/commonDialogActions';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';


export const {
  actionTypes,
  actions,
  api,
  jsxActions,
} = createDialogActions({

  config: {
    getSubmitMethod: ({isEditMode}) =>
      isEditMode  ? toolsService.updateToolType : toolsService.createToolType,
  },

  apiOverrides: {
    fetchDialogData(dispatch, getState) {
      return function () {

        let promise1 = toolsService.fetchToolTypes();
        let promise2 = toolsService.getToolCategories();
        let promise3 = kitTypesService.fetchAllKitTypes();
        let promise4 = locationsService.fetchActiveLocations();
        let promise5 = operationsService.fetchAllOperations();

        return Promise.all([promise1, promise2, promise3, promise4, promise5]).then((allResults) => {
          let isResultValid = allResults.every((result) => {
            return Network.isResponseValid(result);
          });
          if (!isResultValid) {
            console.error('Get Tool Types initial data failed.');
            return { success: false };
          }

          let toolTypes = allResults[0].dataList || [];
          let toolCategories = allResults[1].dataList || [];
          let kitTypes = allResults[2].dataList || [];
          let locations = allResults[3].dataList || [];
          let operations = allResults[4].dataList || [];

          let toolMaintenanceOperations = operations.filter((x) => { return x.operationType === 'TOOL_MAINTENANCE' });

          toolMaintenanceOperations = [{
            id: 'none',
            displayName: createLabelHelper('').get('mat.administration.matsettings.dialog.createtooltype.operation.none')
          }, ...toolMaintenanceOperations]; // Adding an empty operation for "no operation" option


          const uniqueFilteredResponse = uniqBy(toolTypes, 'description').filter(item => item.description);

          let dialogData = {
            toolTypes: uniqueFilteredResponse.map((obj) => { return { value: obj.id, label: obj.description, data: obj } }),
            toolCategories: toolCategories.map((obj) => { return { value: obj.id, label: obj.businessId, data: obj } }),
            kitTypes: kitTypes.map((obj) => { return { value: obj.id, label: obj.businessId, data: obj } }),
            stations: locations.map((obj) => { return { value: obj.id, label: obj.name, data: obj } }),
            operations: toolMaintenanceOperations
              .map((x) => {
                return {
                  value: x.id,
                  label: x.displayName,
                  data: {
                    ...x,
                    stations: _getOperationStations(x.id, locations)
                  }
                };
              }),
          };

          dispatch(actions.fetchDialogDataReady(dialogData));
          return dialogData;
        });
      }
    },
  },

});

/////////////////////////////////////////////////////////////////////////
// PRIVATE HELPERS

function _getOperationStations(operationId, locations = []) {
  return locations
    .filter((x) => x.operations?.some(({ id }) => id === operationId))
    .map((x) => ({ value: x.id, label: x.name, data: x }));
}

// /////////////////////////////////////////
// // ACTION TYPES - PUBLIC, FOR REDUCERS
// export const actionTypes = {
//   CREATE_TOOLTYPE_DIALOG_SHOW: 'CREATE_TOOLTYPE_DIALOG_SHOW',
//   CREATE_TOOLTYPE_DIALOG_HIDE: 'CREATE_TOOLTYPE_DIALOG_HIDE',
//   CREATE_TOOLTYPE_DIALOG_SUBMIT_IN_PROGRESS: 'CREATE_TOOLTYPE_DIALOG_SUBMIT_IN_PROGRESS',
//   CREATE_TOOLTYPE_DIALOG_SUBMIT_FINISHED: 'CREATE_TOOLTYPE_DIALOG_SUBMIT_FINISHED',
//   CREATE_TOOLTYPE_DIALOG_FETCH_DATA_READY: 'CREATE_TOOLTYPE_DIALOG_FETCH_DATA_READY',
// };
//
//
// ////////////////////////////////////////////////////////////////
// // PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
// const actions = {
//   show: function (payload) {
//     return { type: actionTypes.CREATE_TOOLTYPE_DIALOG_SHOW, payload: payload };
//   },
//   hide: function (payload) {
//     return { type: actionTypes.CREATE_TOOLTYPE_DIALOG_HIDE, payload: payload };
//   },
//   submitInProgress: function (payload) {
//     return { type: actionTypes.CREATE_TOOLTYPE_DIALOG_SUBMIT_IN_PROGRESS, payload: payload };
//   },
//   submitFinished: function (payload) {
//     return { type: actionTypes.CREATE_TOOLTYPE_DIALOG_SUBMIT_FINISHED, payload: payload };
//   },
//   fetchDilaogDataReady: function (payload) {
//     return { type: actionTypes.CREATE_TOOLTYPE_DIALOG_FETCH_DATA_READY, payload: payload };
//   },
// };
//
//
// /////////////////////////////////////////////////////
// // METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
// export let jsxActions = {};
//
// jsxActions.hide = function () {
//   return function (dispatch, getState) {
//     api.hide(dispatch, getState)();
//   };
// };
//
// jsxActions.submit = function (data, isEditMode, reloadParentComponent) {
//   return function (dispatch, getState) {
//     return api.submit(dispatch, getState)(data, isEditMode, reloadParentComponent);
//   };
// };
//
// /////////////////////////////////////////////////////////////////////////
// // API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
// export let api = {};
//
// api.hide = function (dispatch, getState) {
//   return function () {
//     dispatch(actions.hide());
//   }
// };
//
// api.show = function (dispatch, getState) {
//   return function (data = null) {
//     api.fetchDialogData(dispatch, getState)().then((response) => {
//       dispatch(actions.show(data));
//     });
//   }
// };
//
// api.fetchDialogData = function (dispatch, getState) {
//   return function () {
//
//     let promise1 = toolsService.fetchToolTypes();
//     let promise2 = toolsService.getToolCategories();
//     let promise3 = kitTypesService.fetchAllKitTypes();
//     let promise4 = locationsService.fetchActiveLocations();
//     let promise5 = operationsService.fetchAllOperations();
//
//     return Promise.all([promise1, promise2, promise3, promise4, promise5]).then((allResults) => {
//       let isResultValid = allResults.every((result) => {
//         return Network.isResponseValid(result);
//       });
//       if (!isResultValid) {
//         console.error('Get Tool Types initial data failed.');
//         return { success: false };
//       }
//
//       let toolTypes = allResults[0].dataList || [];
//       let toolCategories = allResults[1].dataList || [];
//       let kitTypes = allResults[2].dataList || [];
//       let locations = allResults[3].dataList || [];
//       let operations = allResults[4].dataList || [];
//
//       // console.log('operations ===> ', operations);
//
//       let toolMaintenanceOperations = operations.filter((x) => { return x.operationType === 'TOOL_MAINTENANCE' });
//       // console.log('toolMaintenanceOperations ===> ', toolMaintenanceOperations);
//       // console.log('stations ===> ', locations);
//
//       toolMaintenanceOperations = [{
//         id: 'none',
//         displayName: 'None'
//       }, ...toolMaintenanceOperations]; // Adding an empty operation for "no operation" option
//
//
//       const uniqueFilteredResponse = uniqBy(toolTypes, 'description').filter(item => item.description);
//
//       let dialogData = {
//         toolTypes: uniqueFilteredResponse.map((obj) => { return { value: obj.id, label: obj.description, data: obj } }),
//         toolCategories: toolCategories.map((obj) => { return { value: obj.id, label: obj.businessId, data: obj } }),
//         kitTypes: kitTypes.map((obj) => { return { value: obj.id, label: obj.businessId, data: obj } }),
//         stations: locations.map((obj) => { return { value: obj.id, label: obj.name, data: obj } }),
//         operations: toolMaintenanceOperations
//           .map((x) => {
//             return {
//               value: x.id,
//               label: x.displayName,
//               data: {
//                 ...x,
//                 stations: _getOperationStations(x.id, locations)
//               }
//             };
//           }),
//       };
//
//       dispatch(actions.fetchDilaogDataReady(dialogData));
//       return dialogData;
//     });
//   }
// };
//
// api.submit = function (dispatch, getState) {
//   return function (data, isEditMode, reloadParentComponent) {
//     dispatch(actions.submitInProgress());
//
//     let method = isEditMode ? toolsService.updateToolType : toolsService.createToolType;
//
//     method(data).then((response) => {
//       dispatch(actions.submitFinished());
//       dispatch(actions.hide());
//
//       if (!Network.isResponseValid(response)) {
//         console.error('Create/Edit tool type failed', response);
//         messageDialogApi.responseError(dispatch, getState)(response);
//         return { success: false };
//       } else {
//         const successLabelKey = isEditMode ? 'editItem' : 'createItem';
//         messageDialogApi.showSuccess(dispatch, getState)(`mat.administration.matsettings.success.${successLabelKey}`, { itemType: 'A Tool Type' });
//       }
//
//       if (reloadParentComponent) {
//         reloadParentComponent();
//       }
//
//       return { success: true };
//     });
//   };
// };


